export default __webpack_public_path__ + "static/media/team114.9531817d.JPG";